// Maps a toast state's icon key to its standalone SVG component.
import { SuccessIcon, ErrorIcon, WarningIcon, InfoIcon, LoadingIcon } from '@/media/svgs'

const ICON_BY_KEY = {
  success: SuccessIcon,
  error: ErrorIcon,
  warning: WarningIcon,
  info: InfoIcon,
  loading: LoadingIcon,
}

const ToastIcon = ({ iconKey, size = 22 }) => {
  const Icon = ICON_BY_KEY[iconKey] ?? InfoIcon
  return <Icon size={size} />
}

export default ToastIcon
